"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function getSourceSetValue(src, size) {
  if (!src) return '';
  var resolutionMap = {
    x1: '',
    x2: '2x',
    x3: '3x'
  };
  return "".concat(src, " ").concat(resolutionMap[size]).trim();
}
var _default = getSourceSetValue;
exports["default"] = _default;